module.exports = __webpack_public_path__ + "img/E15.c85d17cd.png";